import React from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import data from '../assets/dt-data/data-blog'
import { Link } from 'react-router-dom';

function Blog01(props) {
    return (
        <div>

            <PageTitle sub='Blog' title='Latest News' />


            <section className="tf-blog">
                <div className="tf-container">
                    <div className="row">
                        {
                            data.map(idx => (
                                <div key={idx.id} className="col-md-6">
                                    <article className="tf-blog-item">
                                        <div className="image">
                                            <Link to="/blog-details-v1"><img src={idx.img} alt="D.T Wallet" /></Link>
                                        </div>
                                        
                                        <div className="title">
                                            <h5><Link to="/blog-details-v1">{idx.title}</Link></h5>
                                            <Link 
                                                to="/blog-details-v1" 
                                                className="tf-button style-1"
                                                style={{
                                                    background: '#FFC107',
                                                    border: 'none',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = '#E6A800';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = '#FFC107';
                                                }}
                                            >
                                                <span style={{ color: '#000', fontWeight: '600' }}>{idx.cate}</span>
                                            </Link>
                                        </div>
                                        <p className="content">{idx.text}</p>
                                        
                                        <div className="meta">
                                            <span className="admin"> <i className="fal fa-user"></i> 
                                                {idx.user}
                                            </span>
                                            <span className="date"><i className="far fa-clock"></i>{idx.time}</span>
                                        </div>
                                    </article>
                                </div>  
                            ))
                        }
                        

                        <div className="col-md-12 ">
                            <div className="load-more">
                                <button 
                                    className="tf-button loadmore" 
                                    type="button"
                                    style={{
                                        background: '#FFC107',
                                        color: '#000',
                                        border: 'none',
                                        fontWeight: '600',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#E6A800';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = '#FFC107';
                                    }}
                                >
                                    Load more
                                </button>
                            </div>
                        </div>                 
                        
                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default Blog01;